/** @jsxImportSource @emotion/react */
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Input, InputProps } from "reactstrap";
import { useDebounce } from "use-debounce";
import { usePagination } from "../../hooks";

export const SearchInput = ({ onSearch, maxWidth = "250px", ...props }: InputProps & { onSearch(value?: string): void; maxWidth?: string }) => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get("query") ?? "";
    const [value] = useDebounce(query, 500);

    const { updateSearchParams } = usePagination();

    useEffect(() => {
        onSearch(value);
    }, [value]);

    return (
        <div style={{ position: "relative", width: "100%", maxWidth }}>
            <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="text-muted"
                style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                }}
            />
            <Input
                type="search"
                name="query"
                onChange={(e) => updateSearchParams("query", e.target.value, true)}
                placeholder="Search by label"
                value={query}
                style={{ paddingLeft: "36px" }}
                {...props}
            />
        </div>
    );
};
